
;
                (function(){
                    const Func = (function() {
                        if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-wa07tkd6ym';
                    document.querySelectorAll('.ecom-wa07tkd6ym').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-7pmunmosost';
                    document.querySelectorAll('.ecom-7pmunmosost').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            